import React from 'react';
import Alert from '@material-ui/lab/Alert';

import useUserPreferencesContext from '../../store/userPreferences/useUserPreferencesContext';
import VideoCardList from '../Video/VideoCardList/VideoCardList';

const Favorites = () => {
  const { favoriteVideos } = useUserPreferencesContext();

  const getVideoPath = (video) => `/favorites/${video.id}`;

  if (favoriteVideos.length === 0) {
    return (
      <Alert severity="error" style={{ margin: 30 }}>
        You haven&apos;t added any video to your favorites yet
      </Alert>
    );
  }
  return <VideoCardList videos={favoriteVideos} getVideoPath={getVideoPath} />;
};

export default Favorites;
